export default __webpack_public_path__ + "static/media/cheque.61571573.jpg";